import React from 'react';
import { Box } from '@mui/material';
import { Views } from 'react-big-calendar';
import { CalendarEventsPeriod } from '@trnsact/trnsact-shared-types';

import { MonthPanel } from './MonthPanel';
import { Calendar, CalendarConnector, CalendarEventCard } from '../calendar';

export const MonthCalendar = () => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 20rem', gap: '0.5rem', height: '100%' }}>
    <CalendarConnector
      period={CalendarEventsPeriod.Month}
      children={props => (
        <Calendar
          step={10}
          timeslots={6}
          view={Views.MONTH}
          views={[Views.MONTH]}
          components={{
            event: props => <CalendarEventCard {...props} />,
          }}
          {...props}
        />
      )}
    />

    <MonthPanel />
  </Box>
);
